import React from 'react';
import { ErrorBoundaryFallback, sendSlackMessage } from 'cademy-shared-web';
import { Environment } from './Environment';
import Bugsnag from '@bugsnag/js';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        if (
            window.location.hostname !== 'localhost' &&
            window.location.hostname !== `beta.${Environment.DOMAIN}}`
        ) {
            sendSlackMessage(
                'Cademy Public app crashed',
                ':fire:',
                `The Public App Crashed and the error boundry fallback component was shown\n*Page:*\n<${window.location.href}> \n*errorInfo:* \`\`\`${errorInfo.componentStack}\`\`\``,
                '#notifications',
                error
            );
        }
        window.analytics.track('Public App Crashed and error boundry fallback shown', {
            error,
            errorInfo: errorInfo.componentStack,
        });

        if (
            process.env.REACT_APP_ENVIRONMENT === 'Production' ||
            process.env.REACT_APP_ENVIRONMENT === 'Stage'
        ) {
            Bugsnag.notify(error);
        }
    }

    render() {
        if (this.state.hasError) {
            return <ErrorBoundaryFallback />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
